import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { G_PREFIX } from "../constants";
import { UpdateHostClassService } from "../services/update-host-class.service";

@Component({
  selector: `
  g-typography,
  [g-typography],
  h1[g-title], h2[g-title], h3[g-title], h4[g-title]`,
  template: "<ng-content></ng-content>",
  styles: [`.g-menu-item{display:flex;position:relative;align-items:center;justify-content:flex-start;overflow:hidden;padding:0 16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;border:none;-webkit-tap-highlight-color:transparent;cursor:pointer;width:100%;text-align:left;box-sizing:border-box;color:inherit;font-size:inherit;background:0 0;text-decoration:none;margin:0;min-height:48px}.g-menu-item:hover:not([disabled]){background:rgba(0,0,0,.04)}.g-menu-item[disabled]{cursor:default;opacity:.38}.g-placeholder{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;width:100%;background-color:var(--color-grey-500);opacity:.5}.g-placeholder.btn::before{display:inline-block;content:""}.g-placeholder-small{min-height:16px}.g-placeholder-standard{min-height:24px}.g-placeholder-glow .g-placeholder{-webkit-animation:2s ease-in-out infinite placeholder-glow;animation:2s ease-in-out infinite placeholder-glow}@-webkit-keyframes placeholder-glow{50%{opacity:.2}}@keyframes placeholder-glow{50%{opacity:.2}}.g-placeholder-wave{-webkit-mask-image:linear-gradient(130deg,#000 25%,rgba(0,0,0,.8) 75%,#000 55%);mask-image:linear-gradient(130deg,#000 25%,rgba(0,0,0,.8) 75%,#000 55%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:2s linear infinite placeholder-wave;animation:2s linear infinite placeholder-wave}@-webkit-keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0;mask-position:-200% 0}}@keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0;mask-position:-200% 0}}b,b.g-typography,strong,strong.g-typography{font-weight:600}a,a.g-typography{color:var(--color-darkBlue-500);text-decoration:none}.g-typography--large{margin-bottom:.5em;font-size:2.125rem;line-height:1.4;font-weight:700}.g-typography--title1,h1,h1.g-typography--title{margin-bottom:.5em;font-size:1.75rem;line-height:1.4;font-weight:700}.g-typography--title2,h2,h2.g-typography--title{margin-bottom:.5em;font-size:1.375rem;line-height:1.4;font-weight:700}.g-typography--title3,h3,h3.g-typography--title{margin-bottom:.5em;font-size:1.25rem;line-height:1.4;font-weight:600}.g-typography--body{margin-bottom:.5em;font-size:1rem;line-height:1.4;font-weight:400}.g-typography--headline{margin-bottom:.5em;font-size:1.0625rem;line-height:1.4;font-weight:600}.g-typography--subHeadline{margin-bottom:.5em;font-size:.9375rem;line-height:1.4;font-weight:400}.g-typography--small{margin-bottom:.5em;font-size:.8125rem;line-height:1.4;font-weight:400}.g-typography--caption{margin-bottom:.5em;font-size:.75rem;line-height:1.4;font-weight:400}`],
  host: { class: "g-typography" },
  providers: [UpdateHostClassService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypographyComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() type:
    | "large"
    | "title1"
    | "title2"
    | "title3"
    | "headline"
    | "body"
    | "subHeadline"
    | "small"
    | "input"
    | "caption" = "body";
  constructor(
    private _updateHostClassService: UpdateHostClassService,
    private _el: ElementRef
  ) {}

  ngOnInit() {}

  private updateClass(): void {
    const prefixCls = G_PREFIX + "-typography";
    this._updateHostClassService.updateHostClass(this._el.nativeElement, {
      [`${prefixCls}--${this.type}`]: this.type,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { type } = changes;
    if (type) {
      this.updateClass();
    }
  }

  ngAfterViewInit(): void {
    this.updateClass();
  }
}
